export const DEFAULT_REPORT_MODEL = 'claude-sonnet-4-6';

const flag = (value, fallback) => (value === undefined || value === null ? fallback : Boolean(value));

/** Advanced report options, filled from an event or a session, otherwise the app defaults. */
export const reportSettingsOf = (raw) => {
  const source = raw && typeof raw === 'object' ? raw : {};
  const questions = Array.isArray(source.questions) ? source.questions.filter(Boolean) : [];
  const pipeline = source.report_pipeline || source.reportPipeline;
  const prompts = source.custom_prompts || source.customPrompts || null;

  return {
    llm_model: source.llm_model || source.llmModel || DEFAULT_REPORT_MODEL,
    deeplinks_enabled: flag(source.deeplinks_enabled ?? source.deeplinksEnabled, true),
    in_depth_enabled: flag(source.in_depth_enabled ?? source.inDepthEnabled, true),
    report_pipeline: pipeline === 'v3' || pipeline === 'v4-s55' ? pipeline : 'v1',
    generate_qa: flag(source.generate_qa ?? source.generateQa, false),
    questions,
    custom_prompts: prompts && Object.keys(prompts).length > 0 ? prompts : null,
  };
};
